import { MdPeople } from 'react-icons/md';
import ManageMyAccountAccess from '../components/ManageMyAccountAccess';
import SectionCard from './SectionCard';

export default function AccessTab() {
  return (
    <SectionCard
      title="Acessos Permitidos"
      icon={MdPeople}
    >
      <ManageMyAccountAccess />
    </SectionCard>
  );
}
